import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren, useMemo } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions, LotProperty } from "../../api/dtos";

export interface ILotPropertyFormByIdRouteProps extends PropsWithChildren {
    lotPropertyId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const LotPropertyFormByIdRoute: FC<ILotPropertyFormByIdRouteProps> = ({
    lotPropertyId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const lotPropertyIdToUse = (params.lotPropertyId ? +params.lotPropertyId : undefined) ?? lotPropertyId ?? undefined;

    const lotId = params.lotId ? +params.lotId : undefined;

    const createData = useMemo(() => new LotProperty({
        lotId: lotId
    }), [lotId]);

    return (
        <ContextFormByIdProvider
            formId={lotPropertyIdToUse}
            formDefinitionIdentifier={FormDefinitions.LotProperty}
            createData={createData}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default LotPropertyFormByIdRoute;
